




















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FormPage from "./FormPage/index.vue";
import ChartPage from "../../../components/ChartPage/index.vue";
import { getCookie } from "@szgc/plt-core-v2";
import Api from "../../../api/index";
import request from "../../../api/request";
import LogTable from "../../../components/LogTable/index.vue";
import { dateFormat } from "../../../util";
import FileList from "../../../components/FileList/index.vue";
import UploadFile from "../../../components/UploadFile/index.vue";

@Component({
  name: "WbenTermProcess",
  components: {
    UploadFile,
    FormPage,
    ChartPage,
    LogTable,
    FileList
  }
})
export default class WbenTermProcess extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  @Prop({
    type: [String, Number],
    default: "all"
  })
  private logType!: any;

  @Prop({
    type: Object,
    default() {
      return {};
    }
  })
  private runTimeFields!: any;

  @Prop({
    type: Boolean,
    default: false
  })
  private fileShow!: boolean;

  private businessId: any = null;
  private processData: any = null;
  private flowData: any = null;
  private title: any = "";
  private userName: any = "";
  private timeText: any = "";
  private prefix: string = "";
  private fileData: any = [];
  private iframeUrl: string = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.processData = JSON.parse(JSON.stringify(newVal));
      this.businessId = this.processData.businessId;
      this.getFlowData();
    }
  }

  /*办结的流程事项数据查询*/
  async getFlowData() {
    const params = {
      businessId: this.processData.businessId,
      clientType: "web"
    };
    try {
      const { success, data, message } = await request({
        url: this.prefix + Api.getTermSingle(),
        method: "post",
        data: params
      });
      if (!success) {
        this.$message.error("获取终止的流程事项数据失败:" + message);
        return false;
      }
      this.title = data.businessName;
      this.userName = data.run.createUserName;
      this.timeText = data.run.createTime ? dateFormat(data.run.createTime) : "--";
      this.flowData = data;
      this.fileData = data.atts;
      if (this.flowData.packageType === 3) {
        const path = JSON.parse(this.flowData.fields.iframe.value).web;
        const searchParams = new URLSearchParams({
          businessId: this.processData.businessId,
          clientType: "web",
          page: "term"
        });
        if (path.indexOf("http:") > -1 || path.indexOf("https:") > -1) {
          this.iframeUrl = `${path}?${searchParams}`;
        } else {
          this.iframeUrl = `${window.origin}${path}?${searchParams}`;
        }
      }
    } catch (error: any) {
      this.$message.error("获取终止的流程事项数据失败:" + error);
    }
  }
}
